import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Observable, of} from 'rxjs';
import {HttpHook} from '../http/http.hook';
import {concatMap, map} from 'rxjs/operators';

@HookClass('pdf')
export class PdfHook extends BaseHook {

}
